import React, { useState, useEffect } from "react";
import Button from 'react-bootstrap/Button';
import { Form } from 'react-bootstrap';
import Miclogo from '../../Images/Miclogo.svg';
import './Chatbot.css';
import { CircularProgress } from '@mui/material';

function NegativeFeedbackInput({inputText, handleInputChange, handleSendFeedback, maxCharacters, styling}) {
  return (
    <>
      <div className={`prompt-container ${styling}`}>
        <Form>
          <Form.Group
            controlId="promptInput"
            className="d-flex align-items-center"
          >
            <Form.Control
              type="text"
              placeholder="Please specify what's wrong or missing"
              value={inputText} // Bind input value
              onChange={handleInputChange} // Handle text change
              className="flex-grow-1 border-0 shadow-none"
              style={{
                backgroundColor: "transparent",
                fontSize: "16px",
                padding: "10px 15px",
                outline: "none",
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault(); // Prevent form submission or newline (if inside a form)
                  handleSendFeedback(true);
                }
              }}
            />
            <Button
              variant="light"
              className="rounded-circle p-0"
              style={{
                border: "none",
                boxShadow: "none",
                width: "32px",
                height: "32px",
                marginLeft: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={Miclogo} alt="" className="me-3" />
            </Button>
          </Form.Group>
          <div className="d-flex justify-content-between align-items-center mt-2 ps-3 py-2">
            <span style={{ fontSize: "12px", color: "#aaa", margin: "0" }}>
              {inputText?.length}/{maxCharacters} {/* Dynamic character count */}
            </span>
              <Button
                className="generate-btn"
                onClick={() => handleSendFeedback(true)}
                disabled={inputText === "" || inputText === null}
              >
                Send Feedback
              </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default NegativeFeedbackInput;
